import { CreateWorkOrderDto, WorkOrder, WorkOrderFilters, WorkOrderWithAppointments } from "@myapp/contract";
import apiClient from "../../../shared/config/axios";
import { Paginated } from "../../../shared/types/IPaginationResponse";

export const workOrderApi = {
  search: (params: WorkOrderFilters & { page: number }) =>
    apiClient.get<Paginated<WorkOrderWithAppointments>>("/work-orders", { params }),

  getById: (workOrderId: string) =>
    apiClient.get<WorkOrderWithAppointments>(`/work-orders/${workOrderId}`),

  create: (data: CreateWorkOrderDto) =>
    apiClient.post<WorkOrder>("/work-orders", data),
};
